var map = {
	"./bottom-row/sync.js": 7807,
	"./copyright/sync.js": 755,
	"./menu/sync.js": 6037,
	"./middle-row/sync.js": 73,
	"./socials/sync.js": 3345,
	"./sync.js": 7679,
	"./top-row/sync.js": 141,
	"./widget-area-1/sync.js": 8720,
	"./widget-area-2/sync.js": 5191,
	"./widget-area-3/sync.js": 3704,
	"./widget-area-4/sync.js": 9871,
	"./widget-area-5/sync.js": 2581,
	"./widget-area-6/sync.js": 6621
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5297;